/**
 * 暫定 ServiceSite。画像上の「お申し込み」ボタン位置（ヘッダー／案内フローティング／
 * コミュニティ／フッターの計4箇所）にクリック領域を重ね、オンボーディング(/purchase)へ遷移する。
 * 座標は元画像 1440x6244 上のボタン位置から算出した % 指定。
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MockImagePage, type Hotspot } from './MockImagePage';

export const ServiceSitePage: React.FC = () => {
  const nav = useNavigate();
  const go = () => nav('/purchase');

  const hotspots: Hotspot[] = [
    { left: 88.0, top: 0.3, width: 11.0, height: 1.1, onClick: go, label: 'お申し込み（ヘッダー）' },
    { left: 77.0, top: 22.7, width: 21.5, height: 1.1, onClick: go, label: 'お申し込みはこちら（ご案内）' },
    { left: 42.0, top: 81.6, width: 16.7, height: 1.2, onClick: go, label: 'お申し込みはこちら（コミュニティ）' },
    { left: 82.0, top: 86.2, width: 14.2, height: 1.0, onClick: go, label: 'お申し込み（フッター）' },
  ];

  return (
    <MockImagePage src="/mock/service.png" alt="GB照らす サービス・料金体系について" hotspots={hotspots} />
  );
};

export default ServiceSitePage;
